module.exports = __webpack_public_path__ + "img/4@2x.a0cfc186.png";